import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useFragment } from "react-relay";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import type { editLevelDefinitionButton_LevelDefinitionFragment$key } from "@relay/editLevelDefinitionButton_LevelDefinitionFragment.graphql";
import { LEVEL_DEFINITION_FRAGMENT } from "./edit-level-definition-button.graphql";
import { EditLevelDefinitionButtonProps } from "./edit-level-definition-button.types";
import { Paths } from "../../../../routes/paths";

export const EditLevelDefinitionButton = ({
	levelDefinitionFragmentRef,
}: EditLevelDefinitionButtonProps) => {
	const { t } = useTranslation("common");
	const levelDefinition = useFragment<editLevelDefinitionButton_LevelDefinitionFragment$key>(
		LEVEL_DEFINITION_FRAGMENT,
		levelDefinitionFragmentRef,
	);

	const navigate = useNavigate();

	const handleOnClick = () => {
		navigate(Paths.levelDefinition.withId(levelDefinition.id).edit.path);
	};

	return (
		<Button
			icon={EpicIcons.PENCIL}
			tooltip={t("levelDefinition.editTooltip")}
			onClick={handleOnClick}
		/>
	);
};
